module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Command","placeholder":"Type a command"},"nl":{"label":"Actie","placeholder":"Zoek een opdracht"}}')
  delete Component.options._Ctor
}
